var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#0092b5",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 14.102l4.282-7.538c.008-.014.024-.023.08 0l4.074 7.401a.976.976 0 00.025 1.532l-3.763 6.788a1.008 1.008 0 00-.86-.006l-3.873-6.899a.971.971 0 00.034-1.278zm-.41 1.534l3.888 6.925a.974.974 0 00-.18.356c-3.139-.752-5.089-1.217-5.852-1.396a9.556 9.556 0 01-.844-1.438l2.492-4.386a1.024 1.024 0 00.496-.06zm-.539-1.883l-3.087-5.5C9.828 7.136 12.439 6.55 15.559 6.5l-4.162 7.326a1.008 1.008 0 00-.586-.073zm-.42.176a.977.977 0 00.034 1.608l-2.29 4.03a9.464 9.464 0 01-.67-2.954l-.463-7.382a.889.889 0 01.332-.748zm6.6 8.998a.974.974 0 00-.175-.355l3.818-6.887a1.018 1.018 0 00.496-.024l2.474 4.494c-.21.432-.452.848-.724 1.245zm-.741 1.2a.993.993 0 00.747-.739l5.456-1.415a9.661 9.661 0 01-2.336 2.092l-3.623 2.314a.914.914 0 01-.244.11zm-.454 0V26.5a.915.915 0 01-.29-.121l-3.623-2.314a9.664 9.664 0 01-2.246-1.982c.99.235 2.793.665 5.409 1.291.08.373.374.668.75.754zm5.37-10.334a1.011 1.011 0 00-.564-.028l-3.997-7.262c3.032.067 5.58.646 7.641 1.735zm.383.241l3.09-5.572a.89.89 0 01.36.769l-.463 7.383a9.465 9.465 0 01-.7 3.025l-2.314-4.203a.974.974 0 00.027-1.402zM16 11.234a.55.55 0 00-.541.534v1.954L12.573 15.5l.309.667 2.577-.844v1.954l-.722.533v.533L16 17.987l1.263.355v-.533l-.722-.533v-1.954l2.533.89.353-.712-2.886-1.778v-1.954a.55.55 0 00-.54-.533z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArn);
export default __webpack_public_path__ + "static/media/arn.24fe0bee5f714a790ad87fbfcf4ee54e.svg";
export { ForwardRef as ReactComponent };